import { Link } from 'react-router-dom';
import { SEO } from '@/components/SEO';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

export function AIAssistantPage() {
  return (
    <>
      <SEO title="AI HR Assistant - Nestor" description="Intelligent chatbot for employee queries, policy information, and self-service" />
      <section className="bg-gradient-to-b from-primary/10 via-background to-background py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">AI HR Assistant</h1>
            <p className="text-xl text-muted-foreground mb-8">Intelligent chatbot that answers employee queries 24/7</p>
            <Button size="lg" asChild><Link to="/demo">Request Demo <ArrowRight className="ml-2 h-4 w-4" /></Link></Button>
          </div>
        </div>
      </section>
    </>
  );
}
